import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '@shared/services/auth/session.service';

type GuardResponse = Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(private router: Router, private sessionService: SessionService) {}

  canLoad(route: Route, segments: UrlSegment[]): GuardResponse {
    if (segments.length > 1) {
      return true;
    } else {
      return this.router.createUrlTree(['/error/unauthorized']);
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResponse {
    const jtiFound = route.params["sessionID"];
    const validSession = this.checkForExistingSession(jtiFound);

    if (jtiFound && validSession) {
      return true;
    } else {
      return this.router.createUrlTree(['/error/unauthorized']);
    }
  }

  checkForExistingSession(jti: string) {
    const valideJTIFound = this.sessionService.getToken(jti);
    return valideJTIFound;
  }
}
